import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  ssccService,
  type SsccSettingDto,
  type SaveSsccSettingRequest,
  type SaveSsccRangeRequest,
} from '../../services/api/ssccService';

// ============================================================================
// SSCC settings thunks — Spec mlinkone-sscc-allocation.
// ============================================================================

export interface SsccListArgs {
  tenantId: number;
  buyerPartyId?: number;
  supplierPartyId?: number;
}

export const listSsccSettings = createAsyncThunk<SsccSettingDto[], SsccListArgs>(
  'sscc/list',
  async (args, { rejectWithValue }) => {
    try {
      return await ssccService.list(args.tenantId, args.buyerPartyId, args.supplierPartyId);
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : 'Failed to load SSCC settings');
    }
  },
);

export const saveSsccSetting = createAsyncThunk<number, SaveSsccSettingRequest>(
  'sscc/saveSetting',
  async (request, { rejectWithValue }) => {
    try {
      return await ssccService.saveSetting(request);
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : 'Failed to save SSCC setting');
    }
  },
);

export const deactivateSsccSetting = createAsyncThunk<number, { id: number; tenantId: number }>(
  'sscc/deactivateSetting',
  async ({ id, tenantId }, { rejectWithValue }) => {
    try {
      await ssccService.deactivateSetting(id, tenantId);
      return id;
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : 'Failed to deactivate SSCC setting');
    }
  },
);

export const saveSsccRange = createAsyncThunk<number, { settingId: number; request: SaveSsccRangeRequest }>(
  'sscc/saveRange',
  async ({ settingId, request }, { rejectWithValue }) => {
    try {
      return await ssccService.saveRange(settingId, request);
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : 'Failed to save SSCC range');
    }
  },
);

export const suspendSsccRange = createAsyncThunk<void, { rangeId: number; suspend: boolean; tenantId: number }>(
  'sscc/suspendRange',
  async ({ rangeId, suspend, tenantId }, { rejectWithValue }) => {
    try {
      await ssccService.suspendRange(rangeId, suspend, tenantId);
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : 'Failed to update SSCC range');
    }
  },
);
